<!-- @format -->
<!-- Translated: yes -->
<template>
  <div ref="code"></div>
</template>

<script>
import API from '@/classes/API';

export default {
  props: {
    initialPublicToken: null,
  },
  data() {
    return {
      publicToken: this.initialPublicToken,
      hasCompleted: false,
    };
  },
  async mounted() {
    if (!this.publicToken) {
      this.publicToken = (
        await API.get('/payments/checkout-session', {
          order: this.$route.query.order,
          code: this.$route.query.code,
        })
      ).publicToken;
    }
    const publicToken =
      this.publicToken ||
      (
        await API.get('/payments/checkout-session', {
          order: this.$route.query.order,
          code: this.$route.query.code,
        })
      ).publicToken;
    if (this.publicToken) {
      /**
       * Render iframe as described here:
       * https://web-checkout-documentation.azurewebsites.net/#2-render-the-checkout-iframe
       */
      const src = `${this.SITE_CONFIG.collector.browser_api_url.replace(
        /\/$/,
        '',
      )}/walley-checkout-loader.js`;
      const s = document.createElement('script');
      s.setAttribute('src', src);
      s.setAttribute('data-token', publicToken);
      s.setAttribute('data-version', 'v2');
      this.$refs.code.appendChild(s);
      document.addEventListener(
        'walleyCheckoutPurchaseCompleted',
        this.handleCollectorCheckoutPurchaseCompleted,
      );
      document.addEventListener(
        'collectorCheckoutPurchaseCompleted',
        this.handleCollectorCheckoutPurchaseCompleted,
      );
    }

    const { data, orderId, ga } = await API.get(
      `/cart/get-for-pixel?checkout_session_id=${this.publicToken}`,
    );

    console.log('Should start checkout GA');
    console.log(orderId);
    console.log(ga);
    window.trackBeginCheckout(ga, orderId, data.value);
  },
  beforeDestroy() {
    document.removeEventListener(
      'walleyCheckoutPurchaseCompleted',
      this.handleCollectorCheckoutPurchaseCompleted,
    );
    document.removeEventListener(
      'collectorCheckoutPurchaseCompleted',
      this.handleCollectorCheckoutPurchaseCompleted,
    );
  },
  methods: {
    handleCollectorCheckoutPurchaseCompleted(event) {
      if (this.hasCompleted) {
        return;
      }
      this.hasCompleted = true;

      this.$emit('purchase-completed', {
        checkout_session_id: this.publicToken,
      });
      console.log('collectorCheckoutPurchaseCompleted / walleyCheckoutPurchaseCompleted');
      console.log(event);
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
</style>



// WEBPACK FOOTER //
// CollectorCheckout.vue?45a66f70